export function About() {
  return (
    <section 
      id="about" 
      className="bg-black pt-40 lg:pt-24 pb-24 md:pb-32 min-h-screen"
    >
      <div className="container mx-auto px-8 md:px-16">
        <div className="max-w-3xl mx-auto">
          <h2 className="mb-12 text-center tracking-wider text-yellow-400">
            A Story of Street Art and Human Expression
          </h2>
          
          <div className="space-y-8 text-white/85 leading-relaxed">
            <p>
              Photography isn't just about capturing a moment — it's about revealing the hidden stories around us.
            </p>
            
            <p>
              From the neon streets of Tokyo to the worn walls of Buenos Aires, I seek art that lives outside galleries — on the streets, raw and honest. My work reflects that tension between creation and control.
            </p>
            
            <p>
              The city walls speak — through peeling posters, faded stencils, and quick strokes of graffiti. Each mark is a voice, a fragment of identity, a small act of defiance.
            </p>
            
            <p>
              Street art is fragile yet fearless — made in public, exposed to time, but filled with urgency. Every photograph is a meeting point between art and place, a glimpse of the stories beneath the surface.
            </p>
            
            <p>
              These are more than photographs; they are traces of resistance, preserved moments of truth.
            </p>
            
            <p className="italic text-yellow-400/90">
              To own one is to hold a piece of that truth — a story that might otherwise fade away.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;